export default class FeeScheduleCategoryName {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: FeeScheduleCategoryName): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): FeeScheduleCategoryName {
    return new FeeScheduleCategoryName("");
  }

  public fromJSON(value: string): FeeScheduleCategoryName {
    return new FeeScheduleCategoryName(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): FeeScheduleCategoryName {
    return new FeeScheduleCategoryName(this.value);
  }
}
